// Alpine directives for custom effects
export function registerCustomDirectives(Alpine) {
  Alpine.directive("scrollbar", (el) => {
    if (OverlayScrollbars)
      OverlayScrollbars(el, {
        scrollbars: {
          visibility: "auto",
          autoHide: "scroll",
        },
      });
  });

  Alpine.directive("splitlinesbottom", (el) => {
    if (!window.gsap || !window.ScrollTrigger) return;
    let animation;
    function setup() {
      animation && animation.revert && animation.revert();
      const children = Array.from(el.children).reverse();
      // Nếu phần tử tiếp theo cũng có splitlinesbottom, thêm delay cho phần tử hiện tại
      if (
        el.nextElementSibling &&
        el.nextElementSibling.hasAttribute("x-splitlinesbottom")
      ) {
        el.style.transitionDelay = "0.2s";
      } else {
        el.style.transitionDelay = "";
      }
      animation = gsap.from(children, {
        y: 120, // xuất hiện từ xa dưới lên
        opacity: 0,
        duration: 0.75, // tăng tốc độ
        ease: "power3",
        stagger: 0.08, // nhanh hơn
        scrollTrigger: {
          trigger: el,
          start: "top 90%",
          once: true,
        },
      });
      el.__splitlinesAnim = animation;
    }
    setup();
    el.__splitlinesSetup = setup;
    // Debounce resize để tránh gọi liên tục
    let resizeTimeout;
    // window.addEventListener("resize", () => {
    //   clearTimeout(resizeTimeout);
    //   resizeTimeout = setTimeout(setup, 200);
    // });
  });

  Alpine.data('anchorNav', (initialId) => ({
    activeTab: '#' + initialId.replace('#', ''),

    scrollTo(id) {
      const cleanId = '#' + id.replace('#', '');
      this.activeTab = cleanId;
      const target = document.querySelector(cleanId);

      if (target) {
        // Tính toán vị trí có trừ hao offset
        const offset = 100; // Tăng lên một chút cho thoáng
        const top = target.getBoundingClientRect().top + window.pageYOffset - offset;

        // Hiệu ứng cuộn mượt mà hơn
        window.scrollTo({
          top: top,
          behavior: 'smooth'
        });

        // Cập nhật URL nhẹ nhàng mà không gây nhảy trang
        history.pushState(null, null, cleanId);
      }
    }
  }));
  // Directive giúp ghim phần tử khi scroll (Sticky Sidebar)
  Alpine.directive("stickysidebar", (el) => {
    if (!window.gsap || !window.ScrollTrigger) return;
    let mm = gsap.matchMedia();
    // Đợi một chút để layout và các ảnh kịp render xong mới tính toán chiều cao
    setTimeout(() => {
      const parentSection = el.closest('section') || el.parentElement;
      mm.add("(min-width: 769px)", () => {
        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: el,
            start: "top 120px", // Khi đỉnh phần tử cách top trình duyệt 100px (tùy chỉnh theo navbar)
            end: () => `bottom+=${parentSection.offsetHeight - el.offsetHeight - 960}px`, // Dừng lại khi chạm đáy section
            pin: true,
            pinSpacing: false,
            anticipatePin: 1,
            // invalidateOnRefresh: true, // Cập nhật lại nếu resize trang
            // markers: true, // Mở cái này lên để debug vị trí start/end nếu cần
          }
        });
        tl.to(el, {
          opacity: 0,
          scale: 0.8,
          filter: "blur(5px)",
          ease: "none",
          scrollTrigger: {
            trigger: parentSection,
            start: "bottom 80%", // Bắt đầu biến mất khi đáy section tới giữa màn hình
            end: "bottom 50%",
            scrub: true
          }
        });
        return () => ST.kill();
      });
    }, 500);
  });
}
